import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [nativeCommsMessageTypes.FILE_PRINT];
